import React, {useEffect, useState} from "react";
import * as DOMPurify from "dompurify";
import Content from "../../content-interface";

const Intro = (props: {
  intro: Content['intro'],
  setCurrStep: React.Dispatch<number>,
  setError: React.Dispatch<string>,
}) => {
  const [cleanHtmlContent, setCleanHtmlContent] = useState('');

  const { intro: {htmlContent} = {}, setCurrStep, setError } = props;
  useEffect(() => {
    if (htmlContent)
      setCleanHtmlContent(DOMPurify.sanitize(htmlContent));
    else
      setError('No intro content defined')
  }, [htmlContent, setError])

  return (
    <div className="Intro">
      <div className="content" dangerouslySetInnerHTML={{__html: cleanHtmlContent}}/>

      <div className="navButtons">
        <button onClick={() => setCurrStep(1)}>Start Self-Assessment</button>
      </div>
    </div>
  );
}

export default Intro;
